import { ContextAware, DetailContext } from "@/app/contexts/detail.context";
import { getObjectContentsFromPath } from "@/app/helpers/stringpath.helper";
import {Store} from "vuex";
import OverviewComponent from "@/app/dynamic-components/overviews/overview-component.vue";
import Vue from "vue";
import {resolveEngine} from "@/app/helpers/resolve.engine";

export class OverviewContext implements ContextAware{
  data: { [key: string]: any } = {};

  public setData(key: string, rule: any): OverviewContext {
    this.data[key] = rule;
    return this;
  }

  public resolvePlaceholders(data: any): any {
    return resolveEngine.resolvePlaceholders(data, this);
  }

  public resolveFieldValue(dataPath: string): any {
    return resolveEngine.resolveFieldValue(dataPath, this);
  }

  public inherit( c: ContextAware ): OverviewContext {
    if (!c || !c.getData()) return this;
    Object.entries(c.getData()).forEach((value) => {
      this.data[value[0]] = value[1];
    });
    return this;
  }

  getData(): { [p: string]: any } {
    return this.data
  }
}
